<template>

<div class="model-card border-grid mb-4">
     <span class="rate-badge">
        <span class="ranking-txt">
            <span class="material-icons-round icon mr-1">&#xe8d0;</span>
            <span class="d-flex align-items-center" v-if='m.rating'>
                {{ m.rating }}<span class="rate-base">/10</span>
            </span>
            <span class="d-flex align-items-center" v-if='!m.rating'>
                 New
            </span>
        </span>
        
        <a :href="url('onlyfans-models/' + m.slug + '#your-review')" class="rate-now">
           Rate Now
        </a>
    </span>

    <!-- <span v-if='m.trending == 1' class="trending">
        Trending <span class="d-none d-sm-inline">Model</span>
    </span> -->

    <a :href="url('onlyfans-models/' + m.slug )" class="img-link d-block position-relative">

        <!-- <span class="top-badge">
            <span class="text">TOP</span>
            <span class="num">
                {{ m.c == 1 ? '1%' : '10%' }}
            </span>
        </span>   -->

        <a v-if='m.only_fans' :href="m.only_fans" class="of-link" title="Link to OnlyFans profile">
            <img src="/resources/images/onlyfans-icon.jpeg" class="of-logo">
        </a>  

        <span class="img-overway text-uppercase">
            <span>
                See <br> profile
                <span class="material-icons-round d-block">&#xea50;</span>
            </span>
        </span>

        <img :alt="m.name" 
             :src="m.img" 
             class="">
    </a>

    <div class="model-info">
        <div class="model-stats d-flex justify-content-center mt-2 mb-2">
            <!-- <fav-btn :m='m.id' :l='m.likes'></fav-btn> -->

            <span class="views">
                <span class="material-icons-round">&#xe8f4;</span>
                {{ m.previews }}
            </span>
            <span class="views" title='onlyfans likes'>
                <span class="material-icons-round">&#xe87d;</span>
                {{ m.of_likes }}
            </span>
            <span class="views" title='onlyfans photos'>
                <span class="material-icons-round">&#xe412;</span>
                {{ m.of_images }}
            </span>
            <span class="views" title='onlyfans videos'>
                <span class="material-icons-round">&#xe04b;</span>
                {{ m.of_videos }}
            </span>
        </div>
        <h3 class="model-name">
            <a :href="url('onlyfans-models/' + m.slug )">{{ m.name }}</a>
        </h3>
        <!-- <div>
           {{ m.desc }}
        </div> -->
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        props : ['m'],

        created() {
           
        },

        data() { 

            return {
                isReady : false,
            }
            
        },

        methods : {

        }

    }
</script>
